"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PutBucketLifecycleConfigurationOutput = {
    type: "structure",
    required: [],
    members: {}
};
//# sourceMappingURL=PutBucketLifecycleConfigurationOutput.js.map